'use client';

import React from 'react';
import { Loader2 } from 'lucide-react';
import { CtaButton } from '@/components/common/CtaButton';
import { useOTSTranslation } from '@/i18n/useOTSTranslation';

// Load More control beneath a region list. Mirrors the resort reviews feed
// (components/resort/ReviewsList) so the two paginated surfaces on the site
// behave the same way.
//
// A failed page leaves the button in place: pressing it again retries, which
// is the whole recovery story and needs no separate error copy.
export const LoadMoreRows = ({
  hasMore, isLoading, onLoadMore,
}: {
  hasMore: boolean;
  isLoading: boolean;
  onLoadMore: () => void;
}) => {
  const { t } = useOTSTranslation('common');

  if (!hasMore) return null;

  return (
    <div className="mt-4">
      <CtaButton
        onClick={onLoadMore}
        disabled={isLoading}
        className="w-full font-bold"
        iconLeft={isLoading ? <Loader2 className="animate-spin" aria-hidden /> : undefined}
        iconRight={null}
      >
        {t('common.loadMore')}
      </CtaButton>
    </div>
  );
};
